// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"TabWrapper__Wrapper_3cvw5","WrapperChilderForm":"TabWrapper__WrapperChilderForm_3dWGJ","Title":"TabWrapper__Title_1sRut"};